<template>
  <div class="flex flex-col gap-4 bg-white p-4 rounded-2xl shadow mb-5">
    <p>
      รวมยอดยกมาสุทธิ <span class="font-semibold text-primary">
      {{ form.netRestructuringAmount }} บาท
        <small class="text-grey">(กรณีมีการชำระเงินต้นเกิน จะเป็นการหักยอดยกมา)</small>
    </span>
    </p>
    <p>
      รวมเงินต้นสุทธิ:<span class="font-semibold text-primary">
      {{ form.netPrincipalAmount }} บาท
        <small class="text-grey">(กรณีมีการชำระยอดยกมาเกิน จะเป็นการหักเงินต้น)</small>
    </span>
    </p>

    <p>
      ยอดชำระปกติต่อเดือน:
      <span class="font-semibold text-primary">{{ form.paymentRoundAmountPrincipal }} บาท</span>
    </p>
    <p>
      ยอดชำระยอดยกมาต่อเดือน:
      <span class="font-semibold text-primary">{{ form.paymentRoundAmountRestructuring }} บาท</span>
    </p>
    <p>
      รวมยอดชำระต่อเดือน:
      <span class="font-semibold text-primary">{{ form.paymentRoundAmount }} บาท</span>
    </p>
    <p>
      รวมยอดชำระเดือนสุดท้าย:
      <span class="font-semibold text-primary">
        {{ form.paymentRoundAmountLast }} บาท
        <small class="text-grey" v-if="Number(form.totalRemain) > 0">({{ form.totalRemain }} บาท)</small>
      </span>
    </p>
    <p>
      วันที่ชำระงวดแรก:
      <span class="font-semibold text-primary">{{ form.firstPaymentDate ? form.firstPaymentDate : '-' }}</span>
    </p>
    <p>
      วันที่ชำระงวดสุดท้าย:
      <span class="font-semibold text-primary">{{ form.lastPaymentDate ? form.lastPaymentDate : '-' }}</span>
    </p>
  </div>
</template>

<script>
/**
 * @typedef {Object} LoanForm
 * @property {number} paymentRoundAmountPrincipal
 * @property {number} paymentRoundAmountRestructuring
 * @property {number} paymentRoundAmount
 * @property {number} paymentRoundAmountLast
 * @property {number} totalRemain
 * @property {string} firstPaymentDate
 * @property {string} lastPaymentDate
 */

export default {
  name: 'SummaryBox',
  props: {
    /** @type {LoanForm} */
    form: {type: Object, required: true}
  },
}
</script>
